import StageCellEditor from './StageCellEditor';
import TagCellEditor from '../tags/TagCellEditor';
import { PipelinePinIcon } from '../../../assets/pipeline/PipelinePinIcon';
import { reilmAPI } from '../../../services/apiClient';

const phoneFormatEval = (n) => {
    if ( n === undefined || n==='' ) return null
    if ( n.length === 10 ) {
        const digits = n?.split('')
        const areacode = `(${digits?.at(0)}${digits?.at(1)}${digits?.at(2)}) `
        const phone = `${digits?.at(3)}${digits?.at(4)}${digits?.at(5)}-${digits?.at(6)}${digits?.at(7)}${digits?.at(8)}${digits?.at(9)}`
        
        return areacode + phone
    }
    return n.replace(/\D/g, "")
    
}

export const getPipelineColumns = ({ activeStage, onStageUpdate, allTags, onTagsUpdate, onManageTags, onNavigate, onPinUpdate }) => [
  {
    field: "property",
    headerName: "Property",
    flex: 2,
    sortable: false,

    renderCell: (params) => {
      return (
        <div
          className="flex flex-col justify-center leading-[1.2] cursor-pointer py-[16px] w-[100%] group"
          onClick={() => onNavigate?.(params.row.id)}
        >
          <span className="text-[13px] font-semibold text-brand-dark group-hover:text-brand-green transition-colors">
            {params.row.addressDisplay}
          </span>

          <span className="mt-[2px] text-[12px] text-brand-unselectedGray">
            {params.row.propertySummary}
          </span>
        </div>
      );
    },
  },
  {
    field: "stage",
    headerName: "Stage",
    width: 220,
    sortable: false,

    renderCell: (params) => (
      <StageCellEditor
        params={params}
        activeStage={activeStage}
        onStageUpdate={onStageUpdate}
      />
    ),
  },

  {
    field: "contact",
    headerName: "Contact",
    width:160,
    sortable: false,

    renderCell: (params) => {
      
      return (
        <div className="flex flex-col justify-center leading-[1.2]">
          <span className="text-[13px] font-semibold text-brand-dark">
            {params.row.contactName}
          </span>

          <span className="mt-[2px] text-[12px] text-brand-unselectedGray">
            {phoneFormatEval(params.row.contactMobile)}
          </span>
        </div>
      );
    },
  },

  {
    field: "createdAtDisplay",
    headerName: "Added",
    width: 100,
    sortable: true,
  },

  {
    field: "tagsDisplay",
    headerName: "Tags",
    width: 296,
    sortable: false,

    renderCell: (params) => (
      <TagCellEditor
        params={params}
        allTags={allTags}
        onTagsUpdate={onTagsUpdate}
        onManageTags={onManageTags}
      />
    ),
  },

  {
    field: "pinned",
    headerName: "",
    width: 64,
    sortable: false,
    disableColumnMenu: true,
    align: 'center',
    headerAlign: 'center',

    renderCell: ({ row }) => (
      <button
        onClick={(e) => {
          e.stopPropagation()
          const next = !row.pinned
          reilmAPI.updatedPropertiesDetails(row.id, { pin: next }).catch(() => {})
          onPinUpdate?.(row.id, next)
        }}
        className="flex items-center justify-center hover:opacity-70 transition-opacity"
        title={row.pinned ? 'Unpin' : 'Pin to top'}
      >
        <PipelinePinIcon active={row.pinned} />
      </button>
    ),
  },
];
